module.exports = __webpack_public_path__ + "fonts/location.svg?v=86567c3c0b2ff4814c041208f3a78d98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = 694
// module chunks = 0